import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import QuoteProductDetail from '../../../quotes/entities/quoteProductDetail';
import { formatDateWithTime } from '@ami/react/core';

export default class ProductThumbSelectionViewWarnings extends React.PureComponent {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
  };

  render() {
    const { entity } = this.props;

    return (
      <Fragment>
        <div className="row justify-content-center text-center">
          <div className="banner-container">
            <div className={`alert alert-warning justify-content-center`}>
              Lead times and availability of the thumb cannot be confirmed until
              the bucket specifications are provided.
              <br />
              It will not be possible submit a PO for this quote until this
              information is provided.
              <br />
              <br />
              {entity.existingBucketSpecsNotAvailableAcknowledgedByUserId && (
                <div>
                  Agreed to by{' '}
                  {entity.existingBucketSpecsNotAvailableAcknowledgedByUserName}{' '}
                  on{' '}
                  {formatDateWithTime(
                    entity.existingBucketSpecsNotAvailableAcknowledgedDate
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row justify-content-center text-center">
          <div className="banner-container">
            <div className="alert alert-warning justify-content-center">
              <i className="fa fa-info-circle fa-lg text-danger"></i> Thumb
              width cannot be confirmed until bucket specifications are
              provided.
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
